import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineLargeButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_LARGE_OUTLINE_BUTTONS, FLAT_LARGE_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatOutlineLargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineLargeButton} span={FLAT_LARGE_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" outline color="primary" id="Tooltip-54" className="btn-square">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-54" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-outline-primary btn-lg</ToolTip>
          {FLAT_LARGE_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} outline={true} size="lg"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatOutlineLargeButtons;
